import adjustColor from '@hellodarwin/core/lib/features/helpers/adjust-color';
import ArrowOutline from '@hellodarwin/icons/dist/icons/ArrowOutline';
import Sider from 'antd/es/layout/Sider';
import styled from 'styled-components';
import { UserMenuButtonStyled } from '../app-layout/components/user-menu/styles';
import { getMenuItemColorsStyling, } from './menu-item/styles';
export const getAppTheme = (theme) => {
    const type = theme.appTheme.type;
    const navigationBgColor = theme.appTheme.navigationBgColor;
    const headerBgColor = theme.appTheme.headerBgColor;
    switch (type) {
        case 'dark':
            return {
                textColor: theme.colors.white_1,
                textHoverColor: theme.colors.purple_3,
                backgroundColor: navigationBgColor,
                burgerBarColor: theme.colors.grey_4,
                burgerBackgroundColor: theme.colors.grey_4,
                headerBgColor: headerBgColor,
                headerItemHoverColor: theme.colors.purple_3,
                headerTextColor: theme.colors.white_1,
                logoBackgroundType: 'dark',
            };
        case 'light':
            return {
                textColor: theme.colors.grey_2,
                textHoverColor: theme.colors.purple_3,
                backgroundColor: navigationBgColor,
                burgerBarColor: theme.colors.grey_2,
                burgerBackgroundColor: theme.colors.grey_4,
                headerBgColor: headerBgColor,
                headerItemHoverColor: theme.colors.white_1,
                headerTextColor: theme.colors.grey_2,
                logoBackgroundType: 'light',
            };
    }
};
export const SocialIcon = styled.svg `
  cursor: pointer;
`;
export const SocialContainer = styled.div `
  color: ${({ theme }) => getAppTheme(theme).textColor};
  ${SocialIcon} {
    color: ${({ theme }) => getAppTheme(theme).textColor};
    &:hover {
      color: ${({ theme }) => getAppTheme(theme).textHoverColor};
    }
  }
`;
export const NavigationDivider = styled.div `
  border-top: 1px solid ${({ theme }) => theme.colors.grey_4};
  width: auto;
  margin-inline: 32px;
`;
export const Navigation = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  min-height: 0;
  padding-inline: 8px;
  padding-block-end: 32px;
  padding-block-start: 16px;
  border-right: 1px solid ${({ theme }) => theme.colors.grey_4};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};

  & > *:first-child {
    flex: 1 1 auto;
    overflow: ${({ $open }) => ($open === false ? 'visible' : 'hidden auto')};
    min-height: 0;
    width: 100%;
    scrollbar-width: thin;
  }

  & > *:last-child {
    flex-shrink: 0;
  }
`;
export const NavigationBrandLink = styled.a `
  width: 100%;
  height: ${({ theme }) => theme.spacing.xxl}px;
  display: flex;
  align-items: center;
  justify-content: ${({ $open }) => ($open ? 'flex-start' : 'center')};
  padding-inline: ${({ theme }) => theme.spacing.md}px;
  margin-block-end: ${({ theme }) => theme.spacing.md}px;
  position: relative;
  flex: 0 0 auto;
  overflow: hidden;
`;
export const NavigationBrandLogo = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  position: ${({ $compact }) => ($compact ? 'absolute' : 'relative')};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: scale(${({ $visible }) => ($visible ? 1 : 0.92)});
  transition:
    opacity 180ms ease,
    transform 180ms ease;
  pointer-events: none;
`;
export const MobileNavigationContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden auto;
  padding: 0;
  gap: 20px;
  height: 100%;

  .hd-navigation-footer {
    ${UserMenuButtonStyled} {
      padding: 0 16px;
    }
  }
`;
export const NavSider = styled(Sider) `
  z-index: 100;
  background-color: ${({ theme }) => getAppTheme(theme).backgroundColor};

  body.natural-scroll & {
    position: sticky !important;
    top: 0;
    align-self: flex-start;
    height: 100vh;
    max-height: 100vh;
  }

  .ant-layout-sider-children {
    overflow: visible !important;
  }
  .ant-layout-sider-trigger {
    position: absolute;
    top: 0;
    z-index: 1100;
    right: -15px;
    background-color: transparent !important;
    color: white;
    width: 30px !important;
    height: 100%;
    cursor: pointer;
  }
`;
export const BurgerBar = styled.div `
  width: 26px;
  height: 2px;
  border-radius: 12px;
`;
export const Burger = styled.div `
  background-color: ${({ theme }) => getAppTheme(theme).burgerBackgroundColor};
  border-radius: 6px;
  padding: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: fit-content;
  aspect-ratio: 1;

  ${BurgerBar} {
    background-color: ${({ theme }) => getAppTheme(theme).burgerBarColor};
  }
  &:hover {
    background-color: ${({ theme }) => adjustColor(getAppTheme(theme).burgerBackgroundColor, 20)};
  }

  ${({ $open }) => ($open ? '' : undefined)}
`;
export const TriggerStyled = styled.div `
  border-radius: 99px;
  box-shadow: 0px 2px 4px 1px rgba(43, 43, 43, 0.15);

  z-index: 1000;
  position: sticky;
  top: 80px;
  width: fit-content;
  height: fit-content;
  width: 24px;
  height: 24px;
  padding: 0;
  display: flex;
`;
export const ArrowOutlineStyled = styled(ArrowOutline) `
  color: #848484;
  .background {
    fill: #f5f5f5;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.white_1};
    .background {
      fill: ${({ theme }) => theme.colors.grey_4};
    }
  }
`;
export const NavigationAccountFooter = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
  border-top: 1px solid ${({ theme }) => theme.colors.grey_4};
  padding-top: ${({ theme }) => theme.spacing.sm}px;
`;
export const LanguageSwitcherStyled = styled.button `
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  padding: ${({ theme }) => theme.spacing.sm}px;
  min-height: ${({ theme }) => theme.spacing.xxl}px;
  width: 100%;
  border: 0;
  border-radius: ${({ theme }) => theme.border_radius.md};
  background: ${({ theme }) => theme.colors.transparent};
  font: inherit;
  cursor: pointer;
  align-items: center;
  justify-content: ${({ $compact }) => ($compact ? 'center' : 'flex-start')};
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
  ${({ theme, $isCurrent, $app }) => getMenuItemColorsStyling(theme, $isCurrent, $app)}
`;
export const DesktopNavigationHeaderContainer = styled.div `
  width: ${({ $navCollapsed }) => ($navCollapsed ? 48 : 178)}px;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`;
